/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetAllEventLookups: {
        $xmlns: 'http://dobs.pa.gov/co/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllEventLookupsResponse.EventTypes.CO_LU_EventType',
      'GetAllEventLookupsResponse.EventFormats.CO_LU_EventFormat',
      'GetAllEventLookupsResponse.TargetAudiences.CO_LU_TargetAudience',
      'GetAllEventLookupsResponse.Programs.CO_LU_Program',
      'GetAllEventLookupsResponse.AARPVolunteers.CO_LU_AARPVolunteer'
    ],
    blueprint: {
      eventTypes: [
        '$..CO_LU_EventType',
        {
          id: '$..ID',
          eventType: '$..EventType'
        }
      ],
      eventFormats: [
        '$..CO_LU_EventFormat',
        {
          id: '$..ID',
          format: '$..Format'
        }
      ],
      targetAudiences: [
        '$..CO_LU_TargetAudience',
        {
          id: '$..ID',
          targetAudience: '$..TargetAudience'
        }
      ],
      programs: [
        '$..CO_LU_Program',
        {
          id: '$..ID',
          program: '$..Program'
        }
      ],
      aarpVolunteers: [
        '$..CO_LU_AARPVolunteer',
        {
          id: '$..ID',
          aarpVolunteer: '$..AARPVolunteer'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
